// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  cognito: {
    region:     'ap-south-1',           // your region
    userPoolId: 'ap-south-1_N6VHV9D7y',  // User Pool ID from Cognito console
    clientId:   '5g1htgnntljf0qa5cm193lonvv',  // App Client ID from Cognito console
  },
  recruitment: {
    apiUrl: 'https://ung43gfmeg.execute-api.ap-south-1.amazonaws.com/default/Kon-RecruitmentHandler',
    publicLinkUrl: 'https://ung43gfmeg.execute-api.ap-south-1.amazonaws.com/default/recruitment/link',
    useMocks: false,
  },
  questions: {
    apiUrl: 'https://tkl088f1k2.execute-api.ap-south-1.amazonaws.com/default/Kon-QuestionsHandler',
  },
  admin: {
    apiUrl: 'https://brxknn3gg1.execute-api.ap-south-1.amazonaws.com/default/Kon-adminHandler',
  },
  uploader: {
    apiUrl: 'https://3c06d9yyd3.execute-api.ap-south-1.amazonaws.com/default/CNN-Comm-3',
  },
  assessmentProctoring: {
    uploadCaptures: false,
  },
};



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
